<template>
  <div class="patient-download">
    <md-card md-with-hover v-if="uploadFileSpinner">
      <md-card-content>
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </md-card-content>
    </md-card>

    <md-card v-if="!uploadFileSpinner && downloadDataUrl != null">
      <md-card-content>
        <div class="md-subhead">
          {{ $t("message.patientFiles") }}
          <tooltip
            :table_tooltip="false"
            :mobile_check="mobile_check"
            :text="'test'"
          ></tooltip>
        </div>

        <br />
        <div style="min-height: 200px">
          <md-list v-if="!smallScreen" style="position: static">
            <md-list-item
              v-for="item in downloadDataUrl"
              v-bind:key="item.url"
              class="file-list-item"
            >
              <md-icon class="material-icons pdf-icon-style"
                >attach_file</md-icon
              >
              <span class="md-list-item-text">{{ item.fileName }}</span>
              <span class="date-list-item">
                {{ $t("message.sentOn") }}
                {{ item.date | moment("DD/MM/YYYY, h:mm:ss a") }}
              </span>
              <span class="download-list-item">
                {{ $t("message.viewOrDownloadFile") }}
              </span>
              <md-button
                v-if="!isIE"
                class="md-icon-button download-icon-item"
                title="Visualizza"
                @click="
                  view_file(
                    item.id,
                    item.fileName,
                    item.downloadUrl,
                    item.communicationID
                  )
                "
              >
                <md-icon>visibility</md-icon>
              </md-button>
              <md-button
                class="md-icon-button download-icon-item"
                title="Scarica"
                @click="
                  download_file(
                    item.id,
                    item.fileName,
                    item.downloadUrl,
                    item.communicationID
                  )
                "
              >
                <md-icon>cloud_download</md-icon>
              </md-button>
              <md-button
                v-if="item.template != 'Referto'"
                class="md-icon-button download-icon-item"
                title="Rispondi"
                @click="send_file(item)"
              >
                <md-icon>send</md-icon>
              </md-button>
            </md-list-item>
          </md-list>
          <md-list v-if="smallScreen" style="position: static">
            <md-list-item
              v-for="item in downloadDataUrl"
              v-bind:key="item.downloadUrl"
              class="file-list-item"
            >
              <md-icon
                class="material-icons pdf-icon-style"
                style="margin-right: 5px"
                >attach_file</md-icon
              >
              <span class="md-list-item-text">{{ item.fileName }}</span>

              <md-button
                class="md-icon-button download-icon-item"
                title="Scarica"
                @click="
                  download_file(
                    item.id,
                    item.fileName,
                    item.downloadUrl,
                    item.communicationID
                  )
                "
              >
                <md-icon>cloud_download</md-icon>
              </md-button>
              <md-button
                v-if="item.template != 'Referto'"
                class="md-icon-button download-icon-item"
                title="Rispondi"
                @click="send_file(item)"
              >
                <md-icon>send</md-icon>
              </md-button>
            </md-list-item>
          </md-list>
        </div>

        <br />
        <md-button
          class="home-button md-raised md-accent normal-button"
          :md-ripple="false"
          @click="logout"
          >{{ $t("message.exitPatient") }}
        </md-button>
      </md-card-content>
    </md-card>
    <div>
      <md-dialog
        :md-active.sync="showDialog"
        :md-click-outside-to-close="false"
      >
        <md-dialog-title>{{ $t("message.choosePatient") }}</md-dialog-title>
        <md-dialog-content>
          {{ $t("message.choosePatMsg1") }}<br />
          {{ $t("message.choosePatMsg2") }}
          <md-list>
            <md-list-item
              v-for="item in patients"
              v-bind:key="item.id"
              @click="choosePatient(item)"
            >
              <span class="md-list-item-text"
                >{{ item.patientName }} {{ item.patientSurname }}</span
              >
            </md-list-item>
          </md-list>
        </md-dialog-content>
      </md-dialog>
      <md-dialog :md-active.sync="showFileDialog" class="file-dialog">
        <md-dialog-content>
          <div class="iframe-div">
            <iframe :src="blobUrl"></iframe>
          </div>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary" @click="showFileDialog = false">{{
            $t("message.close")
          }}</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-confirm
        :md-active.sync="logout_active"
        :md-title="$t('message.disconnetti')"
        :md-content="$t('message.disconMessage')"
        :md-confirm-text="$t('message.exit')"
        :md-cancel-text="$t('message.cancel')"
        @md-cancel="logout_active = false"
        @md-confirm="logout()"
      />
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import parsley from "parsleyjs";
import $ from "jquery";
import axios from "axios";
import moment from "moment";
import languagePicker from "../components/language-picker/LanguagePicker.vue";
import Tooltip from "../components/tooltip/Tooltip.vue";

export default {
  name: "PatientDownload",
  data() {
    return {
      pdfURL: "",
      name: null,
      surname: null,
      patientMail: null,
      patientBirthDate: null,
      patientId: null,
      patientTelNumber: null,
      primaryMail: null,
      secondaryMail: null,
      downloadDataUrl: [],
      uploadFileSpinner: true,
      showLogoutOptions: false,
      user: null,
      patients: [],
      showDialog: false,
      smallScreen: false,
      showFileDialog: false,
      blobUrl: "",
      logout_active: false,
      isIE: false
    };
  },
  computed: {
    mobile_check() {
      window.mobileCheck = function() {
        let check = false;
        (function(a) {
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
              a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4)
            )
          )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      };
      return window.mobileCheck();
    }
  },
  mounted: function() {
    //console.log(this.$route.query.ref)
    var self = this;
    var ua = window.navigator.userAgent;
    self.isIE = /MSIE|Trident/.test(ua);
    //console.log(self.isIE);
    var window_media = window.matchMedia("(max-width: 768px)");
    self.test_match_mview(window_media);
    window_media.addListener(self.test_match_mview);
    //console.log(self.$route);
    // controllo esistenza stringa in firestorage
    // controllo auth
    self.user = firebase.auth().currentUser;
    //console.log(self.user);

    if (self.user) {
      // da mettere ciclo per controllare se + providerData
      if (self.user.providerData[0].providerId == "phone") {
        self.$store.commit("userLoggedIn", true);
        self.userPhone = self.user["phoneNumber"];
        //console.log("Phone-Authenticated user");

        self.checkUserRegistration();
        //check utente codice
        //get file URL
      } else {
        self.$store.commit("setRedirectPath", self.$route.fullPath);
        //console.log("User not Phone-Authenticated");
        self.$router.push("/phone-auth");
      }
    } else {
      //console.log("User not Authenticated");
      self.$store.commit("setRedirectPath", self.$route.fullPath);
      self.$router.push("/phone-auth");
    }
  },
  methods: {
    send_file: function(item) {
      var self = this;
      console.log(item);
      self.$store.commit("replyCommunicationID", item.communicationID);
      self.$store.commit("replyPatientID", item.patientID);
      self.$store.commit("replyLocationID", item.locationID);
      self.$router.push("/registration-upload");
    },
    test_match_mview: function(window_media) {
      var self = this;
      //console.log("test_match_view");
      if (window_media.matches) {
        self.smallScreen = true;
        //console.log("small");
        //console.log(self.smallScreen);
      } else {
        self.smallScreen = false;
        //console.log("large");
        //console.log(self.smallScreen);
      }
    },
    download_file(itemId, filename, url, communicationID) {
      var self = this;
      //console.log('download');
      //console.log(filename);
      //console.log(url);
      var storage = firebase.storage();
      var httpsReference = storage.refFromURL(url);
      httpsReference
        .getDownloadURL()
        .then(function(file_url) {
          //console.log(file_url);
          //console.log('storage download');
          fetch(file_url)
            .then(r => r.blob())
            .then(blob => self.showFile(blob, filename));

          /*
          var ua = window.navigator.userAgent;
          var isIE = /MSIE|Trident/.test(ua);
          console.log(isIE);
          var xhr = new XMLHttpRequest();
          console.log('creazione xhr');
          xhr.responseType = "blob";
          if ( isIE ) {
            console.log('IE');
            axios({
              method: 'get',
              url: file_url,
              responseType: 'blob'
            })
              .then(function (response) {
                console.log('mssaveoropenblob');
                window.navigator.msSaveOrOpenBlob(response.data, filename);
              });
            //IE specific code goes here

          }
          else{
            xhr.onload = function(event) {
            console.log('xhr onload');

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              console.log('mssaveoropenblob');
              window.navigator.msSaveOrOpenBlob(xhr.response, filename);
            } else {
              console.log('no ms');
              var a = document.createElement("a");
              var link = window.URL.createObjectURL(xhr.response);
              console.log(link);
              a.href = link;

              //a.target = "_blank";
              a.download = filename;
              a.style.display = "none";
              document.body.appendChild(a);
              console.log('click');
              //a.click();
              document.body.removeChild(a);
            }

          };
          xhr.open("GET", file_url);
          xhr.send();
          }*/
        })
        .then(function(data) {
          firebase
            .auth()
            .currentUser.getIdToken(/* forceRefresh */ true)
            .then(function(idToken) {
              axios
                .post(
                  "/api/setLastView",
                  {
                    itemId: itemId
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + idToken
                    }
                  }
                )
                .catch(function(err) {
                  console.log(err);
                });
            });
          axios
            .post(
              "/api/logging",
              {
                component: "PAZIENTE",
                event: "Download file",
                patientID: self.patientId,
                communicationID: self.communicationID,
                description: filename + " - " + url
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(data) {
              //console.log("SUCCESS!!");
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    view_file: function(itemId, filename, url, communicationID) {
      var self = this;
      var storage = firebase.storage();
      var httpsReference = storage.refFromURL(url);
      httpsReference.getDownloadURL().then(function(file_url) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.onload = function(event) {
          self.blobUrl = window.URL.createObjectURL(xhr.response);
          self.showFileDialog = true;
          firebase
            .auth()
            .currentUser.getIdToken(/* forceRefresh */ true)
            .then(function(idToken) {
              axios
                .post(
                  "/api/setLastView",
                  {
                    itemId: itemId
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + idToken
                    }
                  }
                )
                .catch(function(err) {
                  console.log(err);
                });
            });
          axios
            .post(
              "/api/logging",
              {
                component: "PAZIENTE",
                event: "Visualizzazione file",
                patientID: self.patientId,
                communicationID: communicationID,
                description: filename + " - " + url
              },
              {
                headers: {
                  //Authorization: 'Bearer ' + idToken
                }
              }
            )
            .then(function(data) {
              //console.log("SUCCESS!!");
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
        };
        xhr.open("GET", file_url);
        xhr.send();
      });
      /*window.open(
        "/download_test?user=" + self.patientId + "&file=" + filename,
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );*/
      /*
      var html_string =
        "<iframe width='100%' height='100%' src='" + url + "'></iframe>";
      let pdfWindow = window.open("");
      pdfWindow.document.write(html_string);*/

      /*
      this.user.getIdToken().then(idToken => {

        axios
          .post(
            "/download",
            {
              user_id: self.user["uid"],
              folder: self.patientId,
              filename: filename,
              url: url
            },
            {
              headers: {
                Authorization: "Bearer " + idToken
              }
            }
          )
          .then(function(response) {
            var fileContent = response["data"]["content"];
            var mimetype = response["data"]["mimetype"];
            var file_string = encodeURI(fileContent);
            var html_string =  "<iframe width='100%' height='100%' src='data:" +
                                mimetype +
                                ";base64, " +
                                file_string +
                                "'></iframe>"
            let pdfWindow = window.open("");



            pdfWindow.document.write(html_string);
            axios
            .post(
                "/logging",
                {
                  component: "PAZIENTE",
                  event: "Visualizzazione file",
                  patientName : self.name,
                  patientSurname : self.surname,
                  patientEmail: self.patientMail,
                  patientNumber: self.patientTelNumber,
                  description: filename


                },
                {
                  headers: {
                    //Authorization: 'Bearer ' + idToken
                  }
                }
              )
              .then(function(data) {
                console.log("SUCCESS!!");
              })
              .catch(function() {
                console.log("FAILURE!!");
              });
          })
          .catch(function(error) {
            //self.addResourceError();
            console.error("ERROR: " + error);
          });

      });*/
    },
    showFile: function(blob, filename) {
      //console.log(blob);
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([blob], { type: blob.type });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename;
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    dynamicSort: function(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result =
          a[property] > b[property] ? -1 : a[property] < b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    getFileFromHumanitas: function(id) {
      var self = this;
      firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          var pageSize = 100;
          var collected = [];
          var pageCount = 0;
          var maxPages = 100;

          function fetchPage(cursor) {
            var payload = {
              collectionName: "fromHumanitas",
              patientID: id,
              type: self.role,
              page_size: pageSize
            };
            if (cursor) {
              payload.cursor = cursor;
            }
            return axios
              .post("/api/getHistory", payload, {
                headers: {
                  Authorization: "Bearer " + idToken
                }
              })
              .then(function(data) {
                var responseData = data.data.data;
                if (responseData && responseData.items) {
                  collected = collected.concat(responseData.items);
                  pageCount += 1;
                  if (responseData.next_cursor && pageCount < maxPages) {
                    return fetchPage(responseData.next_cursor);
                  }
                } else if (Array.isArray(responseData)) {
                  collected = responseData;
                } else {
                  collected = [];
                }
                return null;
              });
          }

          fetchPage(null)
            .then(function() {
              self.uploadFileSpinner = false;
              self.downloadDataUrl = collected;
            })
            .catch(function(error) {
              //console.log("FAILURE!!");
              //console.log(error);
            });
        })
        .catch(function(error) {
          console.log("firebase token not found");
        });
    },
    logout: function() {
      var self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          console.log("logout", "pd");
          self.$store.commit("userLoggedIn", false);
          self.$router.push({
            path: "/"
          });
        });
    },
    choosePatient: function(item) {
      var self = this;
      //console.log("choosepatient");
      self.patientId = item.id;
      self.name = item.patientName;
      self.surname = item.patientSurname;
      self.patientMail = item.patientMail;
      self.patientBirthDate = item.patientBirthDate;
      self.patientTelNumber = item.patientTelNumber;
      if (self.showDialog) self.showDialog = false;
      axios
        .post(
          "/api/logging",
          {
            component: "PAZIENTE",
            event: "Login e accetazione trattamento dati",
            patientID: self.patientId
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          //console.log("SUCCESS!!");
        })
        .catch(function() {
          //console.log("FAILURE!!");
        });
      self.getFileFromHumanitas(self.patientId);
    },
    checkUserRegistration: function() {
      var self = this;
      firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function(idToken) {
          axios
            .get("/api/patientsFromNumber", {
              headers: {
                Authorization: "Bearer " + idToken
              }
            })
            .then(function(data) {
              console.log("SUCCESS!!");
              console.log(data.data.data);
              var patients_list = data.data.data;
              if (patients_list.length > 1) {
                self.patients = patients_list;
                self.showDialog = true;
              } else if (patients_list.length == 1) {
                self.choosePatient(patients_list[0]);
              }

              //self.patientMail = data.data.data["patientMail"];
              //self.patientTelNumber = data.data.data["patientTelNumber"];
              //self.id_patient = self.patientID;
            })
            .catch(function() {
              //console.log("FAILURE!!");
            });
        })
        .catch(function(error) {
          console.log("firebase token not found");
        });

      /*
      var self = this;
      var db = firebase.firestore();
      var query = db
        .collection("patients")
        .where("patientTelNumber", "==", self.$store.state.detailPhone);

      query.get().then(function(querySnapshot) {
        //console.log(querySnapshot["docs"].length);

        if (querySnapshot["docs"].length > 1) {
          querySnapshot.forEach(function(doc) {
            var temp_patient = {
              id: doc.id,
              patientMail: doc.data().patientMail,
              patientBirthDate: doc.data().patientBirthDate,
              patientName:
                doc
                  .data()
                  .patientName.charAt(0)
                  .toUpperCase() + doc.data().patientName.slice(1),
              patientSurname:
                doc
                  .data()
                  .patientSurname.charAt(0)
                  .toUpperCase() + doc.data().patientSurname.slice(1),
              patientTelNumber: doc.data().patientTelNumber
            };
            self.patients.push(temp_patient);
            self.showDialog = true;
            ////console.log(doc.data())
          });
        } else if (querySnapshot["docs"].length == 1) {
          querySnapshot.forEach(function(doc) {
            //console.log(doc.data());
            var temp_patient = {
              id: doc.id,
              patientMail: doc.data().patientMail,
              patientBirthDate: doc.data().patientBirthDate,
              patientName:
                doc
                  .data()
                  .patientName.charAt(0)
                  .toUpperCase() + doc.data().patientName.slice(1),
              patientSurname:
                doc
                  .data()
                  .patientSurname.charAt(0)
                  .toUpperCase() + doc.data().patientSurname.slice(1),
              patientTelNumber: doc.data().patientTelNumber
            };
            self.choosePatient(temp_patient);
            self.patients.push(temp_patient);
            //console.log(doc.data())
          });
        }
      });
      */
    }
  },
  components: {
    languagePicker,
    Tooltip
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.logout {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}

.home-button {
  width: 30%;
}

.md-card {
  width: 80%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.title-style {
  color: #027953;
}

.first-nav {
  background-color: #ffffff !important;
}

.pdf-icon-style {
  float: left !important;
  color: #ea5b0c !important;
}

.user-mail {
  background-color: #f2f1f2;
  text-transform: lowercase;
  border-radius: 22px;
}

.person-icon {
  color: #027953;
}

.file-list-item:hover {
  background-color: var(
    --md-theme-default-divider-on-background,
    rgba(0, 0, 0, 0.12)
  );
}

.download-list-item {
  display: none;
}

.download-icon-item {
  display: none;
}

.file-list-item:hover .download-icon-item {
  display: inline-block;
}

.file-list-item:hover .download-list-item {
  display: inline-block;
}

.file-list-item:hover .date-list-item {
  display: none;
}

.file-dialog {
  width: 60%;
  height: 80%;
}

.file-dialog .iframe-div {
  display: flex;
  width: 100%;
  height: 100%;
}

.file-dialog .iframe-div iframe {
  width: 100%;
  height: 100%;
}

@media only screen and (max-width: 600px) {
  .file-dialog {
    width: auto;
    height: auto;
  }

  .md-card {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PatientDownload.vue